import {
    Box,
    Button,
    List,
    ListItemButton,
    Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import { useUserStore } from '../../stores/user-store';

export default function Sidebar({
    chats,
    activeChat,
    onNewChat,
    onSelectChat,
    ChatSessionList,
    activeChatId,
}) {
    const userData = useUserStore;
    const navigate = useNavigate();

    const LogOut = () => {
        userData.setState({ userId: '', name: '', username: '', email: '', mobile: '', profile: '', orgId: '', orgName: '', token: '', isLogin: false });
        navigate('/login');
    }
    return (
        <Box
            width={260}
            bgcolor="#202123"
            color="#ECECF1"
            display="flex"
            flexDirection="column"
            p={1}
            height="100vh"   // 🔴 important
        >
            {/* New Chat */}
            <Button
                fullWidth
                startIcon={<AddIcon />}
                onClick={onNewChat}
                sx={{
                    border: "1px solid #4d4d4f",
                    color: "#ECECF1",
                    mb: 1,
                }}
            >
                New chat
            </Button>

            {/* Chat list */}
            <List sx={{ flex: 1, overflowY: "auto", mb: 1 }}>
                {ChatSessionList.map((chat) => (
                    <ListItemButton
                        key={chat._id}
                        selected={chat._id === activeChatId}
                        onClick={() => onSelectChat(chat._id)}
                        sx={{
                            mb: 0.5,
                            borderRadius: 1,
                            transition: "background-color 0.15s ease",

                            /* default */
                            bgcolor: "#2F3037",
                            color: "#ECECF1",

                            /* hover (not selected) */
                            "&:hover": {
                                bgcolor: "#3A3B41",
                            },

                            /* selected */
                            "&.Mui-selected": {
                                bgcolor: "#ffffff",
                                color: "#000",

                                /* selected + hover */
                                "&:hover": {
                                    bgcolor: "#f5f5f5",
                                },
                            },
                        }}
                    >
                        <Typography noWrap fontSize={14}>
                            {chat.title}
                        </Typography>
                    </ListItemButton>

                ))}
            </List>

            {/* Logout button pinned bottom */}
            <Button
                fullWidth
                variant="outlined"
                color="error"
                onClick={LogOut}
                sx={{
                    borderColor: "#ff4d4f",
                    color: "#ff4d4f",
                    "&:hover": {
                        bgcolor: "rgba(255, 77, 79, 0.1)",
                        borderColor: "#ff4d4f",
                    },
                }}
            >
                Logout
            </Button>
        </Box>

    );
}
